import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import PageTitle from "./components/PageTitle";
import Analytics from "./components/Analytics";
import { CartProvider } from "./context/CartContext";

// Genel sayfalar
import Home from "./pages/Home";
import About from "./components/About";
import Stores from "./components/Stores";
import FAQSection from "./components/FAQSection";
import Communication from "./components/Communication";

// Kurumsal sayfalar
import KalitePolitikamiz from "./pages/KalitePolitikamiz";
import Bayilikler from "./pages/Bayilikler";


// Kategori / Ürün
import Urunler from "./components/Urunler";
import UrunDetay from "./pages/UrunDetay";
import Hesaplayicilar from "./pages/Hesaplayicilar";
import MarkaSayfasi, { MarkaDizini } from "./pages/MarkaSayfasi";
import Karsilastir from "./pages/Karsilastir";
import ToptanTeklif from "./pages/ToptanTeklif";
import TeklifListesi from "./pages/TeklifListesi";
import VitrinSayfasi from "./pages/VitrinSayfasi";
import RehberYazisi, { RehberListesi } from "./pages/Rehber";
import KarsilastirmaCubugu from "./components/KarsilastirmaCubugu";
import UygulamaKur from "./components/UygulamaKur";

// Ortak
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <Router>
      <CartProvider>
      <ScrollToTop />
      <PageTitle />
      <Analytics />
      <Navbar />
      <Routes>
        {/* Genel Sayfalar */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/stores" element={<Stores />} />
        <Route path="/sss" element={<FAQSection />} />
        <Route path="/iletisim" element={<Communication />} />
        <Route path="/kurumsal/kalite-politikamiz" element={<KalitePolitikamiz />} />
        <Route path="/bayilikler" element={<Bayilikler />} />

        {/* Kaldırılan eski tanıtım sayfaları: eski bağlantılar ilgili kataloğa gider */}
        <Route path="/haberler" element={<Navigate to="/" replace />} />
        <Route path="/selsil" element={<Navigate to="/urunler/sizdirmazlik-urunleri" replace />} />
        <Route path="/banyo-mutfak" element={<Navigate to="/urunler/vitrifiye-ve-armaturler" replace />} />
        <Route path="/banyo-dolaplari" element={<Navigate to="/urunler/vitrifiye-ve-armaturler" replace />} />
        <Route path="/sprey-boya" element={<Navigate to="/urunler/boya-firca-ve-rulo-grubu" replace />} />
        <Route path="/modern-aksesuarlar" element={<Navigate to="/urunler/vitrifiye-ve-armaturler" replace />} />
        <Route path="/banyo-aksesuar" element={<Navigate to="/urunler/vitrifiye-ve-armaturler" replace />} />

        {/* Ürünler */}
        <Route path="/urunler" element={<Urunler />} />
        <Route path="/urunler/:slug" element={<Urunler />} />
        <Route path="/urun/:id" element={<UrunDetay />} />
        <Route path="/hesaplayicilar" element={<Hesaplayicilar />} />
        <Route path="/markalar" element={<MarkaDizini />} />
        <Route path="/marka/:slug" element={<MarkaSayfasi />} />
        <Route path="/karsilastir" element={<Karsilastir />} />
        <Route path="/toptan-teklif" element={<ToptanTeklif />} />
        <Route path="/teklif-listesi" element={<TeklifListesi />} />
        <Route path="/yeni/:slug" element={<VitrinSayfasi />} />
        <Route path="/rehber" element={<RehberListesi />} />
        <Route path="/rehber/:slug" element={<RehberYazisi />} />

        {/* Bilinmeyen adresler */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <KarsilastirmaCubugu />
      <UygulamaKur />
      </CartProvider>
    </Router>
  );
}


export default App;
